import { ReactNode } from "react";

import { AuthRole, PermissionArea } from "api/common/types/auth.types";
import { valueof } from "api/common/utils/type.utils";

// --- Sidebar Item Type Discriminator ---

export const SIDEBAR_ITEM_TYPES = {
  NAV: "nav",
  COLLAPSIBLE: "collapsible",
} as const;
export type SidebarItemType = valueof<typeof SIDEBAR_ITEM_TYPES>;

// --- Sidebar Item Variants ---

interface SidebarItemBase {
  icon: ReactNode;
  label: string;
  allowedRoles?: AuthRole[];
  requiredArea?: PermissionArea;
}

export interface SidebarNavItem extends SidebarItemBase {
  type: typeof SIDEBAR_ITEM_TYPES.NAV;
  link: string;
}

export interface SidebarSubItem {
  label: string;
  link: string;
}

export interface SidebarCollapsibleItem extends SidebarItemBase {
  type: typeof SIDEBAR_ITEM_TYPES.COLLAPSIBLE;
  children: SidebarSubItem[];
}

export type SidebarOptionConfig = SidebarNavItem | SidebarCollapsibleItem;
